namespace GeniuzPOS.ReportMasterData {
    export interface Report_1317Form {
    }

    export class Report_1317Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1317';
    }
}
